import React from "react";
import { Modal, Input, Table, Popover, Button, DatePicker, } from "antd";
import {AddWasteProfile} from "./AddWasteProfile";
import {AddUpdateHotSheetForm} from "../../tracks/hotsheet/popups/AddUpdateHotSheet";
import {AddUpdateHotSheet} from "../../tracks/hotsheet/popups/AddUpdateHotSheet";

const {RangePicker} = DatePicker;
const Search = Input.Search;
const content = (
    <div className="action-column action-dropdown">
      <a title="View"><i className="fa fa-eye" /></a>
      <a title="Edit"><i className="fa fa-pencil" /></a>
      <a title="Print"><i className="icon-printer" /></a>
    </div>
);

export class ProjectLogAccount extends React.Component {

columns = [
  {
    title: 'Client',
  dataIndex: 'client',
  key: 'client',
},{
  title: 'Site',
  dataIndex: 'site',
  key: 'site',
},{
  title: 'Bill To',
  dataIndex: 'bill_to',
  key: 'bill_to',
},{
  title: 'Contact',
  dataIndex: 'contact',
  key: 'contact',
},{
  title: 'Manager',
  dataIndex: 'manager',
  key: 'manager',
},{
  title: 'Scope',
  dataIndex: 'scope',
  key: 'scope',
},{
  title: 'Start Date',
  dataIndex: 'start_date',
  key: 'start_date',
},{
  title: 'Status',
  dataIndex: 'status',
  key: 'status',
},{
  title: 'Financial Status',
  dataIndex: 'financial_status',
  key: 'financial_status',
},{
  title: 'Task',
  dataIndex: 'task',
  key: 'task',
},{
    title: <div>P&L<br /> Summary</div>,
  dataIndex: 'pl_summary',
  key: 'pl_summary',
},{
    title: 'Alert',
  dataIndex: 'alert',
  key: 'alert',
},{
    title: 'Action',
    render: item => <div className="action-column">
      <a title="View"><i className="fa fa-eye" /></a>
      <a title="Edit"><i className="fa fa-pencil" /></a>
      <a title="Print"><i className="icon-printer" /></a>
    </div>
  },
];

 data = [{
   key: '1',
   client: '562145',
   site:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   bill_to:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   contact:'Mike Rosati',
   manager:'Julia Anderson',
   scope:'US Removal',
   start_date:'2018-12-05',
   status: 'Approved',
   financial_status: <div>Approved<br/>ID: <div className="id-gen">16988</div></div>,
   task:'6/10',
   pl_summary:<div>12.6%<br/><div className="id-gen">$123467</div></div>,
   alert:<div>Margin<br/><div className="id-gen">12.6%</div></div>,
},{
   key: '2',
   client: '562145',
   site:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   bill_to:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   contact:'Mike Rosati',
   manager:'Julia Anderson',
   scope:'US Removal',
   start_date:'2018-12-05',
   status: 'Approved',
   financial_status: <div>Approved<br/>ID: <div className="id-gen">16988</div></div>,
   task:'6/10',
   pl_summary:<div>12.6%<br/><div className="id-gen">$123467</div></div>,
   alert:<div>Margin<br/><div className="id-gen">12.6%</div></div>,
},{
   key: '3',
   client: '562145',
   site:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   bill_to:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   contact:'Mike Rosati',
   manager:'Julia Anderson',
   scope:'US Removal',
   start_date:'2018-12-05',
   status: 'Approved',
   financial_status: <div>Approved<br/>ID: <div className="id-gen">16988</div></div>,
   task:'6/10',
   pl_summary:<div>12.6%<br/><div className="id-gen">$123467</div></div>,
   alert:<div>Margin<br/><div className="id-gen">12.6%</div></div>,
},{
   key: '4',
   client: '562145',
   site:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   bill_to:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   contact:'Mike Rosati',
   manager:'Julia Anderson',
   scope:'US Removal',
   start_date:'2018-12-05',
   status: 'Approved',
   financial_status: <div>Approved<br/>ID: <div className="id-gen">16988</div></div>,
   task:'6/10',
   pl_summary:<div>12.6%<br/><div className="id-gen">$123467</div></div>,
   alert:<div>Margin<br/><div className="id-gen">12.6%</div></div>,
},{
   key: '5',
   client: '562145',
   site:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   bill_to:<div>Test<br/>ID: <div className="id-gen">16988</div></div>,
   contact:'Mike Rosati',
   manager:'Julia Anderson',
   scope:'US Removal',
   start_date:'2018-12-05',
   status: 'Approved',
   financial_status: <div>Approved<br/>ID: <div className="id-gen">16988</div></div>,
   task:'6/10',
   pl_summary:<div>12.6%<br/><div className="id-gen">$123467</div></div>,
   alert:<div>Margin<br/><div className="id-gen">12.6%</div></div>,
},];

  render() {
    const { visible } = this.props;

    return (
      <Modal closable={false} centered visible={visible} onOk={() => this.props.onCancel()}
             onCancel={() => this.props.onCancel()} width='75%' className="view-data-modal view-hotsheet-mdl">
            <div className="row m-0">
              <div className="col-sm-6 col-12 view-modal-header">
                <h3><span>Project Log</span></h3>
              </div>
              <div className="col-sm-6 col-12 view-modal-header">
                  <RangePicker width={"100%"} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="listing-table">
                  <Table className="responsive-table table table-hover waste-profile-tbl" columns={this.columns} dataSource={this.data} />
                </div>
              </div>
            </div>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/popups/ProjectLogAccount.jsx